import React from 'react';
import Image from 'gatsby-image';

export const WagtailImage = ({ renditionName = 'cover', image, ...props }) => {
    const imageSrc = image[renditionName] ? image[renditionName].src : '';
    return (
        <Image
            aria-label={`Background Image: ${image.alt}`}
            fluid={{
                ...image,
                src: imageSrc,
            }}
            {...props}
        />
    );
};

export const WagtailImageBackground = ({ backgroundImage, backgroundUrl, className, style, alt }) =>
    backgroundImage ? (
        <WagtailImage className={className} style={style} image={backgroundImage} aria-hidden />
    ) : (
        <div
            aria-label={`Background Image: ${alt}`}
            className={className}
            style={{
                backgroundImage: `url(${backgroundUrl})`,
                ...style,
            }}
        />
    );

export default WagtailImage;
